<template>
  <div class="report-filter-more-type-container">
    <!--树状模式 -->
    <div class="tree-filters" v-if="filters.length">
      <el-collapse v-model="expandIds">
        <el-collapse-item v-for="filter in filters" :key="filter.id" :name="filter.id">
          <div class="custom-title name-and-icon-class" slot="title" @click="disposeIcon(filter.id)" :title="filter.name">
            <i :class="getIcon(filter.id)"></i>
            <span :class="['name', filter.required && 'required']">{{ filter.name }}</span>
          </div>
          <div class="options">
            <div class="item-option name-and-icon-class" v-for="(option, i) in options[filter.id]" :key="i + option">
              <span :class="['name', getItemIcon(filter, option.id) && 'active-name']" :title="option.name" @click="checkItem(filter, option.id)">{{ option.name }}</span>
              <template v-if="filter.moreType === 'tree'">
                <i v-if="getItemIcon(filter, option.id)" class="el-icon-check"></i>
              </template>
              <template v-else>
                <el-checkbox :value="!!getItemIcon(filter, option.id)" :checked="!!getItemIcon(filter, option.id)" @change="checkItem(filter, option.id)"></el-checkbox>
              </template>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
export default {
  name: 'report-filter-more-type',
  props: ['report', 'reportFilters'],
  data () {
    return {
      expandIds: [],
      checkOptions: {},
      options: {},
      filters: []
    }
  },
  created () {
    this.initFilters()
    this.initOptions()
  },
  methods: {
    getTreeFilters () {
      return this.reportFilters.filter(r => r.moreType === 'tree')
    },
    getCheckFilters () {
      return this.reportFilters.filter(r => r.moreType === 'check')
    },
    disposeIcon (id) {
      if (this.expandIds.length === 0) {
        this.expandIds.push(id)
      } else {
        let i = this.expandIds.findIndex(c => c === id)
        i !== -1 ? this.expandIds.splice(i, 1) : this.expandIds.push(id)
      }
    },
    initOptions () {
      this.reportFilters && this.reportFilters.forEach(report => {
        // 数据源下拉框
        if (report.dataSource && report.dataSource.enable) {
          // 加载选项
          this.initParams(report)
        } else {
          // 静态模板
          let options = report.template && report.template.stringOptions && report.template.stringOptions.trim().split('\n').map(el => {
            return {name: el, id: el}
          })
          this.$set(this.options, report.id, options)
        }
      })
    },
    checkItem (filter, id) {
      let array = this.checkOptions[filter.id]
      if (array) {
        // 判断当前选项是否开启了多选
        let i = array.findIndex(c => c === id)
        if (i > -1 && filter.required) {
          let result = this.checkOptions[filter.id]
          if (!result || result.length === 1) {
            return this.$message.error(`${filter.name}必填`)
          }
        }
        i !== -1 ? array.splice(i, 1) : filter.multipleChoice ? array.push(id) : this.$set(this.checkOptions, filter.id, [id])
      } else {
        this.$set(this.checkOptions, filter.id, [id])
      }
      this.$nextTick(() => this.$emit('search', this.checkOptions, filter))
    },
    initFilters () {
      // 树状在前 勾选在后
      // 找出所有设置了默认值的筛选项
      let defaultValueFilters = this.reportFilters.filter(r => r.defaultValue)
      defaultValueFilters && defaultValueFilters.length && defaultValueFilters.forEach(d => this.$set(this.checkOptions, d.id, [d.defaultValue]))
      this.filters = [...this.getTreeFilters(), ...this.getCheckFilters()]
      this.$nextTick(() => {
        this.filters.forEach(c => this.expandIds.push(c.id))
      })
    },
    initParams (report) {
      let params = {'index': 1, 'size': 1000, filters: {}}
      // 有dataSource.filter需要先看绑定的筛选条件是否有值
      if (report.dataSource.filter && Object.keys(report.dataSource.filter).length !== 0) {
        Object.keys(report.dataSource.filter).forEach(el => {
          params.filters[el] = this.checkOptions[report.dataSource.filter[el]] || ''
        })
        this.searchOptions(params, report)
      } else {
        this.searchOptions(params, report)
      }
    },
    searchOptions (params, report) {
      this.$axios.get(`/report-api/report/data/${report.dataSource.reportId}`, {params}).then(res => {
        let options = res.data.map(n => {
          return {id: n[report.dataSource.columnId], name: n[report.dataSource.showColumnId]}
        })
        this.$set(this.options, report.id, options)
      })
    }
  },
  computed: {
    getIcon () {
      return id => this.expandIds.find(c => c === id) ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
    },
    getItemIcon () {
      return (filter, id) => {
        let array = this.checkOptions[filter.id]
        return array ? array.find(c => c === id) : array
      }
    }
  }
}
</script>

<style lang="scss">
.report-filter-more-type-container {
  .el-collapse {
    border: none;
    outline: none;
    .el-collapse-item {
      .el-collapse-item__header {
        height: 28px;
        line-height: 28px;
        border: none;
        outline: none;
        .el-collapse-item__arrow {
          display: none;
        }
        .custom-title {
          width: 100%;
          height: 28px;
          line-height: 28px;
          .name {
            width: calc(100% - 18px);
            padding-left: 10px;
          }
        }
      }
      .el-collapse-item__wrap {
        border: none;
        .el-collapse-item__content {
          padding-bottom: 0;
          .options {
            .item-option {
              text-align: left;
              height: 28px;
              line-height: 28px;
              &:hover {
                background-color: #ECF5FF;
              }
              .name {
                width: calc(100% - 30px);
                cursor: pointer;
                padding-left: 23px;
              }
              .active-name, .el-icon-check {
                color: #54ABF1;
              }
              .el-checkbox {
                .el-checkbox__input {
                  .el-checkbox__inner {
                    background-color: #fff;
                    border-color: #DCDFE6;
                    &::after {
                      border-color: #54ABF1;
                    }
                  }
                }
                .is-checked {
                  .el-checkbox__inner {
                    border-color: #54ABF1;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .name-and-icon-class {
    display: flex;
    align-items: center;
    color: #323232;
    &:hover {
      color: #323232;
    }
    .name {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: inline-block;
      text-align: left;
      color: #323232;
      font-size: 12px;
      position: relative;
      &:hover {
        color: #323232;
      }
    }
    .required {
      &:after {
        content: '*';
        color: #F56C6C;
        margin-right: 4px;
        position: absolute;
        left: 2px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/report/runtime/report-filter-more-type.vue